<template lang="pug">
  #deposit.body: .body-inner
    //- Broker mode ------------------------------------------------------------
    .broker_modes.no-select
      .modes-heading
        h4.title(v-text="text.modeTitle")
        .help: UiTooltip(:content="tooltips.modes" theme="light")
      ul.modes-list: li(v-for="({v, t}) in brokerModes" :key="`k_${v}`")
        input(type="radio" :id="`id_${v}`" :value="v" v-model="brokerModesModel")
        label(:for="`id_${v}`")
          span: UiIcon(icon="ui-icon-check")
          h4.title {{ t }}
    //- Deposit ----------------------------------------------------------------
    .deposit.no-select
      .deposit-heading
        h4.title(v-text="text.depositTitle")
        .help: UiTooltip(:content="tooltips.deposit" theme="light")
      .deposit-value {{ fakeDeposit|tdSplit|addCurSym }}
      .deposit-slider(ref="depositSliderElement")
</template>

<script>
import tdSplitter from '@/utils/thousandSplitter' // Thousand splitter
import noUiSlider from 'nouislider' // noUiSlider lib
import { _cfg } from '@/config'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Deposit',
  // Created -------------------------------------------------------------------
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
  },
  // Mounted -------------------------------------------------------------------
  mounted () {
    this.depositSlider() // Init deposit slider
  },
  // Before destroy ----------------------------------------------------- [Hook]
  beforeDestroy () {
    this.$refs.depositSliderElement.noUiSlider.off('.depositSlider')
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      fakeDeposit: 0,
      text: _cfg.text.investmentStrategy, // Component text
      tooltips: _cfg.text.tooltips
    }
  },
  // Watch ---------------------------------------------------------------------
  watch: {
    brokerModesModel (v) {
      _cfg.common.currency = _cfg.common.modesCurrency[v]
      this.updateDepositSlider(v)
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', ['getPortfolioData']),
    // Broker modes
    brokerModes () {
      return _cfg.common.modes.map(m => ({ v: m, t: _cfg.text.modes[m] }))
    },
    // Broker modes model
    brokerModesModel: {
      get () { return this.getPortfolioData.mode },
      set (v) { this.SET_PORTFOLIO_FIELD({ f: 'mode', v }) }
    },
    // Robot message
    robotMessage () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida') return 'Инвестиционный портфель начинается с решения о размере планируемых начальных вложений.'
      if (branded === 'ds') return 'Инвестиционный портфель начинается с решения о размере планируемых начальных вложений.'
      if (branded === 'scapital') return 'Инвестиционный портфель начинается с решения о размере планируемых начальных вложений.'
      return 'Базовая настройка параметров портфеля...'
    }
  },
  // Filters -------------------------------------------------------------------
  filters: {
    // Split value by thousand
    tdSplit: function (value) { // Value format splitter
      return tdSplitter(value)
    },

    // Add currency symbol
    addCurSym (value) {
      return `${value} ${_cfg.common.currency}`
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', ['SET_CURRENT_VIEW']),
    // Vuex map mutations of the User SM
    ...mapMutations('moduleUser', ['SET_PORTFOLIO_FIELD']),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', ['sendMessage']),
    // Get slider range
    getSliderRange (mode) {
      const brand = this.$store.state.config.branded
      if (mode === _cfg.common.modes[1]) return _cfg.deposit.range
      return brand === 'anderida' || brand === 'ds' || brand === 'scapital'
        ? _cfg.deposit.rangeAnderida
        : _cfg.deposit.range
    },
    // Deposit slider
    depositSlider () {
      noUiSlider.create(this.$refs.depositSliderElement, {
        snap: true,
        connect: [true, false],
        start: this.getPortfolioData.deposit,
        range: this.getSliderRange(this.getPortfolioData.mode),
        pips: {
          mode: 'steps',
          stepped: true,
          format: { to: function (value) { return '' } }
        }
      })
      // Update event (fires every handle slide)
      this.$refs.depositSliderElement.noUiSlider.on('update.depositSlider', (values, handle, unencoded) => {
        this.fakeDeposit = unencoded[0]
      })
      // Set event (fires only if handle stop sliding)
      this.$refs.depositSliderElement.noUiSlider.on('set.depositSlider', (values, handle, unencoded) => {
        if (this.fakeDeposit !== this.getPortfolioData.deposit) this.SET_PORTFOLIO_FIELD({ f: 'deposit', v: unencoded[0] })
      })
    },
    // Update deposit slider
    updateDepositSlider (v) {
      if (this.$refs.depositSliderElement.noUiSlider) {
        this.$refs.depositSliderElement.noUiSlider.updateOptions(
          { range: this.getSliderRange(v) },
          false // Boolean 'fireSetEvent'
        )
        this.$refs.depositSliderElement.noUiSlider.set(_cfg.deposit.start)
      }
    },
    // Self back validator
    backSelf () {
      return true
    },
    // Self next validator
    async nextSelf () {
      this.sendMessage({ e: 'DepositComplete' })
      return true
    }
  }
}
</script>
